import React from 'react';
import './ServicesSection.css';

const ServicesSection = ({ onNavigateToBrowseRFQs }) => {
  const categories = [
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <rect x="2" y="3" width="20" height="14" rx="2" ry="2"/>
          <line x1="8" y1="21" x2="16" y2="21"/>
          <line x1="12" y1="17" x2="12" y2="21"/>
        </svg>
      ),
      title: 'Web Development',
      description: 'Build websites, web apps, and e-commerce platforms',
      skills: ['React', 'WordPress', 'Shopify', 'HTML/CSS'],
      color: '#3b82f6'
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M12 19l7-7 3 3-7 7-3-3z"/>
          <path d="M18 13l-1.5-7.5L2 2l3.5 14.5L13 18l5-5z"/>
          <path d="M2 2l7.586 7.586"/>
          <circle cx="11" cy="11" r="2"/>
        </svg>
      ),
      title: 'Graphic Design',
      description: 'Create logos, branding, and marketing materials',
      skills: ['Illustrator', 'Photoshop', 'Canva', 'Figma'],
      color: '#ec4899'
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <line x1="12" y1="1" x2="12" y2="23"/>
          <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/>
        </svg>
      ),
      title: 'Bookkeeping',
      description: 'Manage finances, invoicing, and tax compliance',
      skills: ['QuickBooks', 'Xero', 'SARS', 'Excel'],
      color: '#10b981'
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <rect x="2" y="7" width="20" height="15" rx="2" ry="2"/>
          <polyline points="17 2 12 7 7 2"/>
        </svg>
      ),
      title: 'Mobile Apps',
      description: 'Develop iOS and Android applications',
      skills: ['React Native', 'Flutter', 'Swift', 'Kotlin'],
      color: '#8b5cf6'
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M23 6l-9.5 9.5-5-5L1 18"/>
          <polyline points="17 6 23 6 23 12"/>
        </svg>
      ),
      title: 'Digital Marketing',
      description: 'Drive traffic and grow your online presence',
      skills: ['SEO', 'Social Media', 'Google Ads', 'Content'],
      color: '#f59e0b'
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
          <polyline points="14 2 14 8 20 8"/>
          <line x1="16" y1="13" x2="8" y2="13"/>
          <line x1="16" y1="17" x2="8" y2="17"/>
        </svg>
      ),
      title: 'Writing & Content',
      description: 'Craft compelling copy and engaging content',
      skills: ['Copywriting', 'Blogging', 'SEO Writing', 'Editing'],
      color: '#06b6d4'
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
          <circle cx="8.5" cy="8.5" r="1.5"/>
          <polyline points="21 15 16 10 5 21"/>
        </svg>
      ),
      title: 'Photography & Video',
      description: 'Capture moments and create visual stories',
      skills: ['Photography', 'Video Editing', 'Adobe Premiere', 'Lightroom'],
      color: '#ef4444'
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/>
        </svg>
      ),
      title: 'IT Support',
      description: 'Troubleshoot tech issues and setup systems',
      skills: ['Windows', 'Mac', 'Networks', 'Hardware'],
      color: '#6366f1'
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
          <polyline points="14 2 14 8 20 8"/>
        </svg>
      ),
      title: 'Legal Services',
      description: 'Draft contracts and handle compliance',
      skills: ['Contracts', 'CIPC', 'Legal Research', 'Compliance'],
      color: '#0ea5e9'
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/>
        </svg>
      ),
      title: 'Data & Analytics',
      description: 'Analyze data and create actionable insights',
      skills: ['Excel', 'Power BI', 'SQL', 'Tableau'],
      color: '#14b8a6'
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
          <circle cx="9" cy="7" r="4"/>
          <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
          <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
        </svg>
      ),
      title: 'Virtual Assistant',
      description: 'Handle admin tasks and support operations',
      skills: ['Admin', 'Scheduling', 'Email', 'Data Entry'],
      color: '#a855f7'
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <circle cx="12" cy="12" r="10"/>
          <line x1="2" y1="12" x2="22" y2="12"/>
          <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
        </svg>
      ),
      title: 'Translation',
      description: 'Translate documents and localise content',
      skills: ['isiZulu', 'isiXhosa', 'English','Afrikaans'],
      color: '#f97316'
    }
  ];

  return (
    <section className="service-categories">
      <div className="categories-content">
        <div className="section-header">
          <div className="section-badge">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
            </svg>
            <span>POPULAR CATEGORIES</span>
          </div>
          
          <h2>Skills That Pay. Projects That Match.</h2>
          
          <p className="section-description">
            Whatever your expertise, there's work waiting. Browse categories to see what businesses 
            need right now. No CV required—just your skills and portfolio.
          </p>
        </div>

        <div className="categories-grid">
          {categories.map((category, index) => (
            <div key={index} className="category-card" style={{'--category-color': category.color}}>
              <div className="category-icon">
                {category.icon}
              </div>
              <h3>{category.title}</h3>
              <p className="category-description">{category.description}</p>
              <div className="category-skills">
                {category.skills.slice(0, 3).map((skill, idx) => (
                  <span key={idx} className="skill-tag">{skill}</span>
                ))}
                {category.skills.length > 3 && (
                  <span className="skill-more">+{category.skills.length - 3}</span>
                )}
              </div>
            </div>
          ))}
        </div>

        <div className="categories-cta">
          <div className="cta-content">
            <div className="cta-text">
              <h3>Ready to Find Your Next Project?</h3>
              <p>Browse active opportunities across all categories. Filter by budget, timeline, and skills.</p>
            </div>
            <button className="btn-browse-projects" onClick={onNavigateToBrowseRFQs}>
              <span>Browse All Projects</span>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <line x1="5" y1="12" x2="19" y2="12"/>
                <polyline points="12 5 19 12 12 19"/>
              </svg>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;